import * as _ from "lodash";

// constants
var LAST_CONTEXT_KEY = "X-Tiz-Last-Distributor-Context";
var CONTEXT_KEY = "X-Tiz-Distributor-Context";
var ONBOARDING_WARNINGS = "X-Tiz-Onboarding-Warnings";

var service = function () {
  if (!window["$rootScope"]) {
    window["$rootScope"] = {};
  }

  const setCurrentDistributorContext = function (id) {
    localStorage.setItem(LAST_CONTEXT_KEY, id);
    sessionStorage.setItem(CONTEXT_KEY, id);
    window["$rootScope"].currentDistributor = id;
  };

  const setOnboardingWarnings = function (warnings, current_user_id) {
    var data = { warnings: warnings, current_user: current_user_id };
    localStorage.setItem(ONBOARDING_WARNINGS, JSON.stringify(data));
  };

  const getOnboardingWarnings = function () {
    return JSON.parse(localStorage.getItem(ONBOARDING_WARNINGS));
  };

  const clearOnboardingWarnings = function () {
    localStorage.removeItem(ONBOARDING_WARNINGS);
  };

  const getActiveDistributors = function () {
    return window["$rootScope"].user?.distributors || [];
  };

  const getPaymentEnabledDistributors = function () {
    return getActiveDistributors().filter(d => d.uses_term_payments);
  };

  const distributorCount = function () {
    return getActiveDistributors().length > 1;
  };

  const getCurrentDistributorId = function () {
    return (
      Number(sessionStorage.getItem(CONTEXT_KEY)) ||
      window["$rootScope"].user?.distributors[0]?.distributor_id
    );
  };

  const getCurrentDistributor = function () {
    return _.find(getActiveDistributors(), { distributor_id: getCurrentDistributorId() });
  };

  const reloadState = function () {
    var currentDistributor = getCurrentDistributor();
    var pathName = window.location.pathname;

    if (_.includes(pathName, "/distributor/sales_reps")) {
      window.location.assign("/distributor/sales_reps");
    } else if (
      pathName == "/distributor.refer" &&
      currentDistributor.uses_referrals == "onboard_retailers"
    ) {
      window.location.assign("/distributor/retailer_onboarding");
    } else if (
      pathName == "/distributor/retailer_onboarding" &&
      currentDistributor.uses_referrals == "refer_and_earn"
    ) {
      window.location.assign("/distributor");
    } else {
      location.reload();
    }
  };

  function initialize() {
    // set web session storage
    var currentDistributorId = Number(sessionStorage.getItem(CONTEXT_KEY));
    if (!currentDistributorId) {
      currentDistributorId = Number(localStorage.getItem(CONTEXT_KEY));
      if (currentDistributorId) {
        sessionStorage.setItem(CONTEXT_KEY, String(currentDistributorId));
      }
    }
    window["$rootScope"].currentDistributor = currentDistributorId || null;
  }

  return {
    initialize: initialize,
    getAllDistributors: getActiveDistributors,
    getCurrentDistributor: getCurrentDistributor,
    hasMultipleDistributors: distributorCount,
    setCurrentDistributorContext: function (id) {
      setCurrentDistributorContext(id);
    },
    setDistributorReloadState: function (id) {
      setCurrentDistributorContext(id);
      reloadState();
    },
    setOnboardingWarnings: setOnboardingWarnings,
    getOnboardingWarnings: getOnboardingWarnings,
    clearOnboardingWarnings: clearOnboardingWarnings,
    getPaymentEnabledDistributors: getPaymentEnabledDistributors,
  };
};

const distributorContext = service();
export default distributorContext;
